import React from 'react';
import { CProgress } from '@coreui/react';

const HumidityWidget = ({ humidity }) => (
  <div>
    <div className="mb-2">Humidity</div>
    <strong>{humidity} (20%)</strong>
    <CProgress className="CProgress-xs mt-2" color="info" value={20} />
  </div>
);

export default HumidityWidget;


